(function () {
    'use strict';

    class ClientPortalResetPasswordController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, UsersManager, RegexService) {
            super($scope, $injector);
            this.__objectType = 'ClientPortalResetPasswordController';

            this.UsersManager = UsersManager;
            this.RegexService = RegexService;

            this.showResetForm = true;
            this.showConfirmation = false;
        }

        onResetPasswordClick() {

            if (this.previewOnly) {
                return;
            }

            this.resetPasswordForm.$setSubmitted();

            if (this.resetPasswordForm.$invalid) {
                return;
            }

            this.emailError = false;
            this.inProgress = true;
            this.UsersManager.sendResetPassword(this.user, {client_portal_company_id: this.portalModel.company_id}).then(() => {
                this.showResetForm = false;
                this.showConfirmation = true;
            }).finally(() => {
                this.showResetForm = false;
                this.showConfirmation = true;
                this.inProgress = false;
            });
        }
    }

    Components.ClientPortalResetPassword = {
        bindings: {
            user: '<',
            portalModel: '<',
            onBackClick: '&',
            previewOnly: '<'
        },
        controller: ClientPortalResetPasswordController,
        name: 'hbClientPortalResetPassword',
        templateUrl: 'angular/app/modules/core/features/login/client_portal/client_portal_reset_password_template.html',
    };

}());